const setMetrixObject = (userMail, form) => {
    const myHeaders = new Headers();

    myHeaders.append('Content-Type', 'application/json');

    const raw = JSON.stringify({ email: userMail });
    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
    };

    fetch(`${ThemeSettings.sourceBackendAPI}/api/user/get-email/`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        window.sk_ENCEML = result.data;
      })
      .catch((error) => {
        console.log('error', error);
        if(form) setTimeout(() => {
          form.querySelector(".error-message").innerText = form.querySelector(".error-message").innerText != '' ? form.querySelector(".error-message").innerText : error.message;
        }, 2000);
      })
  };